"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VAULT_FACTORY_ADDRESSES = void 0;
const context_1 = require("@derivation-tech/context");
exports.VAULT_FACTORY_ADDRESSES = {
    [context_1.CHAIN_ID.BASE]: '0xEFB4fce343B56741C6bECE6C5bAfB0eC564B914C',
};
